import axios from 'axios';

export const updateScreenHost = (hostData, token) => {
    return axios.put(process.env.REACT_APP_API_URL + '/admin/updateScreenHost', hostData, {
        headers: { Authorization: token }
    });
};
